<lib-starbase-wizard #reportsInvoiceWizard
    [open]="true"
    [initialObject]="filter"
    [wizardTitle]="'Generate Invoice Report for a Specific Customer'"
    [theSteps]="generateInvoiceReportSteps"
    [darkMode]="darkMode"
    (completedEmitter)="generateReport($event)"
    (cancelEmitter)="wizardCancelledEmitter.emit()">
    <ng-content></ng-content>
</lib-starbase-wizard>

<ng-template #step1 let-wrapperForm = "wrapperForm">
    <div [ngClass]="{'defaultMode': !darkMode,'darkMode': darkMode}">
      <div style="flex-wrap: wrap; width: 100%; margin-top: 10px; text-align: center;">
        <h3 class="fal fa-file-invoice-dollar">
          Invoice Report Info
        </h3>
        <h6>
            Please select a Date Range
        </h6>
      </div>
      <div class="row" style="padding-left: 1em; justify-content: center; align-items: center;">
        <div style="width: 30%; text-align: end;">
          <label style="margin-top: 8px; margin-right: 1em;">Report Date Range:</label>
        </div>
        <div style="width: 40%;">
          <div class="input-group input-group-sm" style="width: 15em;">
            <input [value]="filterDateFrom ? (filterDateFrom | date: 'MM/dd/yyyy') + ' - ' + (filterDateTo | date: 'MM/dd/yyyy') : ''"
            placeholder="Date Range" id="dateRange" name="dateRange"
            #scaleticketDateRange
            bsDaterangepicker
            [bsConfig]="bsConfig"
            (bsValueChange)="dateRangeChange($event)"
            class="form-control"
            [ngClass]="{'btn-dark': darkMode}"
            aria-describedby="cal-addon"
            matTooltip="Set a invoice date range filter"
            aria-label="Invoice Dash Date Range">
          </div>
        </div>
      </div>

    </div>
  </ng-template>

  <ng-template #step2 let-wrapperForm="wrapperForm">
    <div class="text-center small alert alert-info mt-0 mb-2" *ngIf="isProcessing">
      <div title="Please wait..." class="ball-pulse">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <lib-customer-select #customerSelect *ngIf="!isProcessing"
              [darkMode]="darkMode"
              [currentCustomers]="customers"
              [dateRange]="!showAll ? [] : [filterDateFrom, filterDateTo]"
              [isInvoice]="true"
              [batchMode]="!isSingleSelectMode"
              [customerSvc]="contactSvc"
              (selectionEmitter)="selectCustomer($event)">
              Select Customers for Invoice Report
    </lib-customer-select>
  </ng-template>

 

